import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, X, Smartphone, Wifi, Bell } from 'lucide-react';
import { usePWA } from '../../../hooks/usePWA';

const PWAInstallPrompt = () => {
  const { isInstallable, installApp, updateAvailable, updateApp } = usePWA();
  const [dismissed, setDismissed] = React.useState(false);

  if (!isInstallable && !updateAvailable) return null;
  if (dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:w-96"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: 'spring', damping: 25, stiffness: 200 }}
      >
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-5">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-secondary-600 rounded-xl flex items-center justify-center">
                <Smartphone size={24} className="text-white" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900">
                  {updateAvailable ? 'Update Available' : 'Install App'}
                </h3>
                <p className="text-sm text-gray-500">
                  {updateAvailable
                    ? 'A new version is ready to install'
                    : 'Add Sasimart to your home screen'}
                </p>
              </div>
            </div>
            <button
              onClick={() => setDismissed(true)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <X size={18} className="text-gray-400" />
            </button>
          </div>

          <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
            <div className="flex items-center gap-1.5">
              <Wifi size={14} className="text-green-500" />
              <span>Works offline</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Bell size={14} className="text-primary-500" />
              <span>Push notifications</span>
            </div>
          </div>

          <motion.button
            className="w-full py-3 bg-gradient-to-r from-primary-500 to-secondary-600 text-white rounded-xl font-semibold shadow-lg flex items-center justify-center gap-2"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={updateAvailable ? updateApp : installApp}
          >
            <Download size={18} />
            {updateAvailable ? 'Update Now' : 'Install App'}
          </motion.button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PWAInstallPrompt;
